import { styled } from '@mui/system'
import { Skeleton } from '@mui/material'

const SkeletonStyled = styled(Skeleton)`
	margin-bottom: 10px;
	transform: scale(1, 1);
`

export { SkeletonStyled }
